import { mods } from "../../utils/mods";

export enum GiroTypes {
	Bankgiro = "Bankgiro",
	Plusgiro = "Plusgiro",
}

const regexps = {
	[GiroTypes.Bankgiro]: /^\d{3,4}-\d{4}$/,
	[GiroTypes.Plusgiro]: /^\d{1,7}-\d$/,
};

export class PGorBG {
	static validate(PGorBG: string): GiroTypes | null {
		const checkSumOk = mods.mod10(PGorBG.replace(/\D/g, ""));

		return !checkSumOk
			? null
			: regexps[GiroTypes.Bankgiro].test(PGorBG)
				? GiroTypes.Bankgiro
				: regexps[GiroTypes.Plusgiro].test(PGorBG)
					? GiroTypes.Plusgiro
					: null;
	}
}
